import { TileGridRenderer } from './tileGrid/TileGridRenderer';
import { TileGridBuilder } from './tileGrid/TileGridBuilder';
import { ImageTypeConfigurationFactory } from './ImageTypeConfigurationFactory';
/**
 * Generate tiles and put given image-data into these tiles.
 */
export class ImageDataTiledRenderer {
    constructor(tileSize) {
        this._imageTypeConfigurationFactory = new ImageTypeConfigurationFactory();
        this._tileGridBuilder = new TileGridBuilder(this._imageTypeConfigurationFactory, tileSize);
        this._tileGridRenderer = new TileGridRenderer(this._imageTypeConfigurationFactory);
    }
    renderToObject3D(object, imageData) {
        const tileGrid = this._tileGridBuilder.build(imageData);
        this._tileGridRenderer.renderToObject3D(object, tileGrid, imageData);
    }
}
//# sourceMappingURL=ImageDataTiledRenderer.js.map